import { colors } from '../../utils/Utils';

const ToolSeparator = ({margin=10}) => {
	return (
		<div style={{ backgroundColor: colors.canvasBackground, height: 2, marginTop: margin, marginBottom: margin, width: '100%' }}></div>
	)
}
export default ToolSeparator;
